import React, { useState } from "react";
import { Box, List, ListItem, TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useFieldArray } from "react-hook-form";

export default function EmailAdresses() {
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    name: "email_addresses_for_failure_notifications",
    keyName: "key",
  });

  const [newEmailAddress, setNewEmailAddress] = useState(null);
  return (
    <>
      <Typography>Email-addresses used for error notification</Typography>
      <List>
        {fields.map((row) => {
          return (
            <ListItem key={row.key ?? row.email}>
              {row.email}{" "}
              <Button
                color={"secondary"}
                onClick={() => {
                  remove(row.email);
                }}
                variant={"outlined"}
              >
                remove
              </Button>
            </ListItem>
          );
        })}
      </List>
      <Button
        color={"primary"}
        onClick={() => {
          setNewEmailAddress("");
        }}
        variant={"contained"}
      >
        Add new email address
      </Button>
      {newEmailAddress != null ? (
        <Box>
          <TextField
            label={"Email-address"}
            onChange={(e) => {
              setNewEmailAddress(e.target.value);
            }}
            value={newEmailAddress}
          />
          <Button
            color={"primary"}
            disabled={!newEmailAddress || fields.findIndex((field) => field.email === newEmailAddress) !== -1}
            onClick={() => {
              append({ email: newEmailAddress, id: newEmailAddress });
              setNewEmailAddress(null);
            }}
            variant={"contained"}
          >
            add
          </Button>
        </Box>
      ) : null}
    </>
  );
}
